controllers.controller('LoginWebtraderController', [
    '$scope', '$ionicHistory', '$state', '$ionicLoading', 'config', 'constants', 'ErrorService', 'UserService',
    'LoginService', 'LocaleService', 'Validator', 'AccountService', '$injector', 'Utils', 'SocialAuthService', 'Storage',
    function ($scope, $ionicHistory, $state, $ionicLoading, config, Const, ErrorService, UserService,
              LoginService, LocaleService, Validator, AccountService, $injector, Utils, SocialAuthService, Storage) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.navigate = function (state) {
            $state.go(state);
        };

        $scope.const = Const;

        $scope.navigateExternalUrl = function(url, openInBroweser) {
            var popupOptions = 'location=no,hidden=no,toolbar=yes,fullscreen=yes,closebuttoncaption=Back,closebuttoncolor=#00AFAA,navigationbuttoncolor=#00AFAA';
            var target = openInBroweser ? '_system' : '_blank'
            window.cordova && window.cordova.InAppBrowser ? window.cordova.InAppBrowser.open(encodeURI(url), target, popupOptions) : window.open(encodeURI(url), '_system');
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.signUpURL = Utils.createLinkByLang('externalLinks.signUp', LocaleService.lang, 'externalLinks.signUpDefault');

        $scope.template = Storage.get('template');

        $scope.validator = Validator.getPattern;

        $scope.socialAuthService = SocialAuthService;

        $scope.disableSignUp = Const['disableSignup'];
        $scope.source = Const['source'];

        $scope.sourcesList = Const['sourcePicklist'];

        $scope.loginForm = {
            login: '',
            password: '',
            source: $scope.sourcesList && $scope.sourcesList.length > 0 ? null : $scope.source.live
        };

        function login(loginForm) {
            //if we are already logged in mt4 account
            var user = UserService.get();
            if (user && user.isLoggedInMT4) {
                return $state.go('root.app.assets', {cache: false});
            }

            $scope.loadingMessage = LocaleService.translation.logging_in;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            function createLoginRequest() {
                if (loginForm.provider && loginForm.tokenThirdParty) {
                    return LoginService.loginThirdParty(loginForm.email, loginForm.provider, loginForm.tokenThirdParty)
                }

                if (Const['authType'] && Const['authType'] === 'webtrader') {
                    return LoginService.loginWebTrader(loginForm.login, loginForm.password, loginForm.source);
                }

                return LoginService.login(loginForm.email, loginForm.password)
            }

            return createLoginRequest()
                .then(function () {
                    $scope.loadingMessage = LocaleService.translation.starting;
                })
                .then(LoginService.initServices)
                .then(function () {

                    $injector.get('Init').isInitialized = true;
                    $ionicLoading.hide();

                    var state = AccountService.checkTradingAccounts();
                    if (state) return $state.go(state);

                    if (Const['showPersonal']) {
                        var user = UserService.get();

                        //check terms
                        if (!user.tnc && Const['tncPopup']) {
                            return $state.go('tnc');
                        }

                        //check state
                        if (user.registrationState <= Const.userState.personal) {
                            return $state.go('root.app.personalDetails');
                        }
                        //check kyc
                        if (user.complianceStatus !== 'approved' && user.registrationState === Const.userState.questionnaire && Const['kycCheck']) {
                            return $state.go('kycCheck');
                        }

                    }

                    if (Const['viewQuestionnaireEnable'] && Storage.get('regulated')) {
                        var user = UserService.get()
                        var showQuestionnaire = Const['showQuestionnaireOnlyIfFunded'] ? user.funded : true;
                        if (user.registrationState === Const.userState.questionnaire && user.classification === "" && user.liveAccountExists && showQuestionnaire) {
                            return $state.go('questionnaireMessage');
                        }
                    }

                    $state.go('root.app.assets');
                })
                .catch(function (error) {
                    if (error.data && error.data.response && error.data.response.code === 3035 && Const['enable2FA']) {
                        $ionicLoading.hide();

                        return $state.go('login-otp', {
                            cache: false,
                            loginData: {
                                'email': $scope.loginForm.email,
                                'password': $scope.loginForm.password
                            }
                        });
                    }

                    if (error === Const.loginStatus.failedActiveAccount) {
                        $ionicLoading.hide();
                        //popup
                        $scope.modal.isError = true;
                        $scope.modal.textTitle = LocaleService.translation.messages.mt4AuthFailed;
                        $scope.modal.back = 'root.app.manageaccounts';
                        $scope.modal.state = true;
                        return;
                    }

                    //if we failed in starting any service - do logout sequence
                    LoginService.logout()
                        .then(function () {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                        .catch(function (error) {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                })
        }


        $scope.login = function (form) {
            Utils.formRevalidate(form);

            if (!form.$valid) return;

            return login(this.loginForm)
        };

        $scope.signinWithGoogle = function () {
            return SocialAuthService.signInWithGoogle()
                .then(function (user) {
                    var loginRequest = {
                        email: user.email,
                        password: "",
                        provider: "google",
                        tokenThirdParty: user.idToken
                    };
                    return login(loginRequest)
                })
        }

        $scope.signinWithFacebook = function () {
            return SocialAuthService.signInWithFacebook()
                .then(function (user) {
                    var loginRequest = {
                        email: user.email,
                        password: "",
                        provider: "facebook",
                        tokenThirdParty: user.token
                    };
                    return login(loginRequest)
                })
        }


    }]);
